import { FC, DragEvent, useEffect } from 'react';
import cx from 'classnames/bind';

import type { IMiniGame } from '@/types/miniGames';

import styles from './Pack.module.scss';
import type { IPack } from '@/types/pack';

interface PackProps {
  setStep: (value: number) => void;
  questionNumber: number;
  setIsShake: (value: boolean) => void;
  pack: IPack;
  miniGames?: IMiniGame[];
}

const cn = cx.bind(styles);

const Pack: FC<PackProps> = ({
  setStep,
  questionNumber,
  setIsShake,
  pack,
  miniGames,
}) => {
  const isTouch = 'ontouchstart' in window || navigator.maxTouchPoints;

  const startGame = () => {
    setStep(3);
  };

  const dragWithCustomImage = (
    e: DragEvent<HTMLLIElement>,
    hideDragImage: Element,
  ) => {
    const target = e.target as HTMLElement;

    const dragImage = target.cloneNode(true) as HTMLElement;
    dragImage.style.opacity = '1';
    dragImage.style.position = 'fixed';
    dragImage.id = 'draggeimage';
    dragImage.style.zIndex = '0';
    dragImage.style.transform = 'scale(1.5)';

    document.body.appendChild(dragImage);
    document.body.appendChild(hideDragImage);

    e.dataTransfer.setDragImage(isTouch ? dragImage : hideDragImage, 25, 25);
  };

  const dragStartHandler = (e: DragEvent<HTMLLIElement>) => {
    setIsShake(false);

    const target = e.target as HTMLElement;

    e.dataTransfer.setData('correctAnswerId', target.id);

    target.style.opacity = '0'; // Скрыть элемент из списка

    const hideDragImage = target.cloneNode(true) as HTMLElement;
    hideDragImage.id = 'hideDragImage-hide';
    hideDragImage.style.display = 'none';

    dragWithCustomImage(e, hideDragImage);
  };

  const dragEndHandler = (e: DragEvent<HTMLLIElement>) => {
    const target = e.target as HTMLElement;
    target.style.opacity = '1'; // Вернуть отображение элемента из списка

    const dragImage = document.getElementById('draggeimage');
    const hideDragImage = document.getElementById('hideDragImage-hide');

    if (dragImage) {
      dragImage.remove();
    }

    if (hideDragImage) {
      hideDragImage.remove();
    }
  };

  const dragHandler = (e: DragEvent<HTMLLIElement>) => {
    const dragImage = document.getElementById('draggeimage');

    if (e.pageX === 0 && e.pageY === 0) {
      return; // При перетаскивании за край экрана оставлять в последней видимой точке
    }

    if (dragImage) {
      dragImage.style.left = `${e.pageX}px`;
      dragImage.style.top = `${e.pageY}px`;
      dragImage.style.pointerEvents = 'none';
      dragImage.style.zIndex = '1';
    }
  };

  useEffect(() => {
    if (miniGames?.length === questionNumber) {
      startGame();
    }
  }, [miniGames, questionNumber]);

  return (
    <li
      key={pack.id}
      className={cn('item')}
      id={String(pack.id)}
      draggable
      onDragStart={dragStartHandler}
      onDragEnd={(e) => dragEndHandler(e)}
      onDrag={dragHandler}
    >
      <img
        draggable={false}
        className={cn('img')}
        src={pack.image}
        alt="Упаковка сигарет"
      />
    </li>
  );
};

export default Pack;
